import React, { useEffect , useContext } from "react";
import WorkInProgressImage from "../../../Assets/Images/maintainance.svg";
import {Button} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import styles from './workInProgress.module.scss';
import CmsDetailsContext from "../../../Context/CmsDetails/CmsDetailsContext";

const WorkInProgress = () => {
  const navigate = useNavigate(); // React Router DOM v6
  const {darkMode } = useContext(CmsDetailsContext);   // Global Variable

  return (
    <div className={`${styles["main-page-not-found"]} mt-12`}>
        <img src={WorkInProgressImage} className={`${styles["work-in-progress-image"]}`} alt="" />
        <h2 className="mt-4 mb-3 text-custom-primary">Work in Progress . . .</h2>
        <p className={darkMode ? "mb-4 text-center" : "mb-4 text-center text-muted"}>Team is currently working on building up the same</p>
        <Button
            className="btn btn-primary mb-3"
            onClick={() => {
            navigate("/catalog/cloud-services")
            }}
        >
            Proceed
        </Button>
    </div>
  )
}

export default WorkInProgress
